"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('select2');
require('./../scss/sites/jaffa/jaffa.scss');
const index_1 = require("./../js/index");
const jaffa_1 = require("./../js/Sites/jaffa");
const ProductsApp_jaffa_1 = require("./ReactComponents/Products/ProductsApp-jaffa");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize Jaffa specific scripts
(0, jaffa_1.InitJaffa)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_jaffa_1.default }));
$(document).ready(function () {
    //Initialize select2 for Jaffa Contact form
    $('.Form__Element.FormSelection select').hide();
    $('.Form__Element.FormSelection select').select2({
        minimumResultsForSearch: Infinity,
        width: 'resolve',
        dropdownParent: $('.Form__MainBody')
    });
});
